(function () {
  SuperloginController.$inject = ["API_URL", "$http", "$rootScope", "$location"];
  angular.module('calendarApp').controller('SuperloginController', SuperloginController);

  function SuperloginController(API_URL, $http, $rootScope, $location) {
    var log = this,
        throbber = $rootScope.throbber;

    log.submitLogin = function () {
      throbber.show();
      log.loginForm.orgid = smooth.orgid;
      $http.post(API_URL + '/customerauth/superlogin', {
        customer: log.loginForm
      }).then(function (reply) {
        throbber.hide();
        var response = reply.data;

        if (!response.success) {
          throbber.showError(response.msg);
          return;
        }

        $location.path('/');
      });
    };
  }
})();